// assets
import { IconCalendarEvent } from "@tabler/icons";

// constant
const icons = { IconCalendarEvent };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const convention = {
  id: "convention",
  // title: "Dashboard",
  type: "group",
  children: [
    {
      id: "convention",
      title: "Convention",
      type: "item",
      url: "/convention",
      icon: icons.IconCalendarEvent,
      breadcrumbs: false,
    },
  ],
};

export default convention;
